// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"R3-z"};